export const htmlLang = document.documentElement.lang.split('-')

export const persistent = true
